import React from 'react'
import Logo from '../Work-Assets/AI_Logo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faStamp, faShop, faSchool, faHouse, faCaretDown, faAddressCard, faAddressBook, faPersonCircleCheck, faSquarePollVertical, faMoneyBill, faComment, faGraduationCap, faPersonMilitaryPointing } from '@fortawesome/free-solid-svg-icons';

function Web_buttons({setLogo_set, setScholarship, setSuluhu, payementgateway, rock, ms, about, client, revs, contacts, school_portal, stude_P, real_estate_portal, setTenancybooking,setHostelbooking,
  setBooking}) {

  const about_btn = () =>
  {
    about(true)
  }

  const clients_btn = () =>
  {
    client(true)
  }

  const rev_btn = () =>
  {
    revs(true)
  }

  const contacts_btn = () =>
  {
    contacts(true)
  }

  const student_PBTN = () =>
  {
      stude_P(true)
  }

  const real_EST = () =>
  {
    real_estate_portal(true)
  }

  const school_PORT = () =>
  {
    school_portal(true)
  }

  const marketing_Space = () =>
  {
    ms(true)
  }

  const guidance_CON = () =>
  {
     rock(true)
  }

  const payment_GW = () =>
  {
    payementgateway(true)
  }

  const suluhu_PBTN = () =>
  {
    //setSuluhu(true)
    setLogo_set(true)
  }

  const student_booking = () =>{
    setBooking(true)
  }

  const scholarship_applicatiob_btn = () =>{
      setScholarship(true)

  }

  return (
    <div className='whole_WB'>
      <div>
          <div className='options'><FontAwesomeIcon icon={faCaretDown} /> Options/Services</div>

          <div className='button_DIV'><FontAwesomeIcon icon={faStamp} className='icon_part' /><button className='non_booking_btn' onClick={student_booking}>Booking Accomodation</button></div>
          
           {<div className='button_DIV'><FontAwesomeIcon icon={faMoneyBill} className='icon_part' /><button onClick={scholarship_applicatiob_btn}>Scholarship Application</button></div>}
          <div className='button_DIV'><FontAwesomeIcon icon={faGraduationCap} className='icon_part' /><button className='non_booking_btn' onClick={student_PBTN}>Student Portal</button></div>
          
          <div className='button_DIV_logo'><div className='AI_LOGO'><img src={Logo} /></div><button className='non_booking_btn' onClick={suluhu_PBTN}>AI Mall</button></div>
          <div className='button_DIV'><FontAwesomeIcon icon={faAddressBook} className='icon_part'/> <button className='non_booking_btn' onClick={contacts_btn}>Contacts</button></div>
          {/*<div className='button_DIV'><FontAwesomeIcon icon={faPersonCircleCheck} className='icon_part' /><button className='non_booking_btn' onClick={clients_btn}>Client Reviews</button></div>**/}
          {/*<div className='button_DIV'><FontAwesomeIcon icon={faSquarePollVertical} className='icon_part' /><button onClick={marketing_Space}>Marketing /Student Promotion Space</button></div>**/}
          {/*<div className='button_DIV'><FontAwesomeIcon icon={faMoneyBill} className='icon_part' /><button onClick={payment_GW}>Payment GateWay</button></div>**/}
          
         <div className='button_DIV'><FontAwesomeIcon icon={faComment} className='icon_part' /><button onClick={rev_btn}>Student news</button></div>
         
        {/*<div className='button_DIV'><FontAwesomeIcon icon={faHouse} className='icon_part' /><button onClick={real_EST}>Real Estate Portal</button></div>**/}
         {/*<div className='button_DIV'><FontAwesomeIcon icon={faSchool} className='icon_part' /><button onClick={school_PORT}>School Portal</button></div>**/}
          <div className='button_DIV'><FontAwesomeIcon icon={faPersonMilitaryPointing} className='icon_part' /><button className='non_booking_btn' onClick={guidance_CON}>Guidance and Counseling</button></div>
          <div className='button_DIV'><FontAwesomeIcon icon={faAddressCard} className='icon_part' /><button className='non_booking_btn' onClick={about_btn}>About Us</button></div>
      </div>
    </div>
  )
}

export default Web_buttons
